import styled from "styled-components";

 export const StyledContainer = styled.div`
    height: 100%;
    font-size: 5vh;
    text-align: center;
    padding-top: 10%;
 `;
